import BlobIcon from '@ilg-totallymoney/ui/components/BlobIcon'
import Box from '@ilg-totallymoney/ui/components/Box'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Heading from '@ilg-totallymoney/ui/components/Heading'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'
import AlertIconBadge from '@ilg-totallymoney/ui/icons/AlertIconBadge'

const ContentPreApprovedAndGuaranteedCreditLimit = () => {
    return (
        <Stack space="space40">
            <Stack space="space20">
                <Flex alignItems="center">
                    <Box mr="space20">
                        <AlertIconBadge />
                    </Box>
                    <Heading variant="60">
                        What does ’pre-approved’ mean?
                    </Heading>
                </Flex>
                <Text color="light">
                    Pre-approval is subject to credit checks. If you apply,
                    you’ll get the card or loan, at the rate advertised,
                    providing the information you give us is accurate and you
                    pass the lender’s final checks.
                </Text>
            </Stack>

            <Stack space="space20">
                <Flex alignItems="center">
                    <Box mr="space20">
                        <AlertIconBadge />
                    </Box>
                    <Heading variant="60">
                        What is Guaranteed Credit Limit?
                    </Heading>
                </Flex>
                <Text color="light">
                    The Guaranteed Credit Limit represents the minimum amount of
                    money that a lender can guarantee upfront, providing you
                    with valuable information to make informed decisions prior
                    to initiating your application process.
                </Text>
                <Flex>
                    <Box mr="space10">
                        <BlobIcon blobName="lightBulb" />
                    </Box>
                    <Box flex={1}>
                        <Text color="light" variant="100">
                            <span style={{ fontWeight: 'bold' }}>Tip:</span> You
                            may see offers below the amount you entered. That’s
                            because lenders may not be able to offer you the
                            full amount, but might be able to do slightly under.
                            The amount is still guaranteed, and you’ll still
                            need to be accepted for the offer.
                        </Text>
                    </Box>
                </Flex>
            </Stack>
        </Stack>
    )
}

export default ContentPreApprovedAndGuaranteedCreditLimit
